export const createXMLTable = (
  tableContent: string,
  fileName: string
): string => {
  return `
    <html xmlns:x="urn:schemas-microsoft-com:office:excel">
      <head>
        <meta charset="UTF-8">
        <xml>
          <x:ExcelWorkbook>
            <x:ExcelWorksheets>
              <x:ExcelWorksheet>
                <x:Name>${fileName}</x:Name>
                <x:WorksheetOptions>
                  <x:Panes></x:Panes>
                </x:WorksheetOptions>
              </x:ExcelWorksheet>
            </x:ExcelWorksheets>
          </x:ExcelWorkbook>
        </xml>
      </head>
      <body>
        <table border='1' bordercolor='white'>
          ${tableContent}
        </table>
      </body>
    </html>
  `;
};
